import styled from "styled-components";

import { Button } from "./Button";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.margins.base_x3};
`;

export const SelectContract = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.margins.base_x2};
`;

export const SelectContractTitle = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.body2};
  font-weight: ${({ theme }) => theme.fonts.weights.semibold};
  line-height: ${({ theme }) => theme.fonts.lineHeights.subtitle};
`;

export const ContractItem = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey200};
  border-radius: ${({ theme }) => theme.border.radius.half};
  padding: ${({ theme }) => theme.margins.base_x1_5};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.margins.quarter};
  width: 100%;
  > *:last-child {
    align-self: flex-end;
  }
`;

export const ContractInfo = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.margins.base};
`;

export const ContractTime = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.margins.half};
`;

export const ContractDuration = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CancelButton = styled(Button).attrs({
  variant: "borderBlue",
})``;

export const ConfirmButton = styled(Button).attrs({
  variant: "blue",
})``;
